import getDateIntervall from './getDateIntervall.jsx'
import sortPerformancesByDate from './sortPerformancesByDate.jsx'
import getPeriodeStartDate from './getPeriodeStartDate.jsx'
import getPeriodeEndDate from './getPeriodeEndDate.jsx'
import getMomentDateObj from './getMomentDateObj.js'
import setMomentDateObjZero from './setMomentDateObjZero.js'
import getDayKey from './getDayKey.js'

const getPerformancesIntervall = (performances, today, timezone, intervallChanger='', weekFilterActive=false) => {
    let dayIntervall
    let shorterIntervallPeriodeEndDate
    const currentPeriodeStartDate = getPeriodeStartDate(today)
    const currentPeriodeEndDate = getPeriodeEndDate(currentPeriodeStartDate)
    const performancesSortedByDate = sortPerformancesByDate(performances)
    const firstCurrentPerformance = performancesSortedByDate.find(performance => setMomentDateObjZero(getMomentDateObj(performance.timeUtc, timezone)).isSameOrAfter(today))

    if(!firstCurrentPerformance) {
        return ''
    }

    const firstcurrentPerformanceDate = setMomentDateObjZero(getMomentDateObj(firstCurrentPerformance.timeUtc, timezone))

    if(weekFilterActive) {
        shorterIntervallPeriodeEndDate = getPeriodeEndDate(today, intervallChanger)
    } else if(intervallChanger !== ''){
        shorterIntervallPeriodeEndDate = getPeriodeEndDate(currentPeriodeStartDate, intervallChanger)
    }

    if(intervallChanger) {
        if(firstcurrentPerformanceDate.isSameOrBefore(shorterIntervallPeriodeEndDate)) {
            dayIntervall = getDateIntervall(today, shorterIntervallPeriodeEndDate)
        } else {
            dayIntervall = getDateIntervall(firstcurrentPerformanceDate, setMomentDateObjZero(getMomentDateObj(performancesSortedByDate[performancesSortedByDate.length - 1].timeUtc, timezone)))
        }
    } else if(intervallChanger === '' && (firstcurrentPerformanceDate.isSameOrBefore(currentPeriodeEndDate))) {
        dayIntervall = getDateIntervall(today, currentPeriodeEndDate)
    } else {
        dayIntervall = getDateIntervall(firstcurrentPerformanceDate, setMomentDateObjZero(getMomentDateObj(performancesSortedByDate[performancesSortedByDate.length - 1].timeUtc, timezone)))
    }

    performances.map(performance => {
        const performanceDate = getMomentDateObj(performance.timeUtc, timezone)
        const key = getDayKey(performanceDate)

        if(dayIntervall.hasOwnProperty(key))  {
            dayIntervall[key].push(performance)
        } else if(performanceDate.isSameOrAfter(currentPeriodeEndDate) && !shorterIntervallPeriodeEndDate) {
            dayIntervall[key] = []
            dayIntervall[key].push(performance)
        }
    })

    return dayIntervall
}

export default getPerformancesIntervall